import { combineReducers } from "redux-immutable";

import phaseReducers from "./phase";

export default combineReducers({
	phase: phaseReducers
});
